
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericDefaultFilled as ObiVesselGenericDefaultFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-default-filled.js';
 
 
 

 
 export const ObiVesselGenericDefaultFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-default-filled',
   elementClass: ObiVesselGenericDefaultFilledElement,
   events: {
     
   }
  });
 
 